import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PageComponent } from './components/page/page.component'
import {AppComponent} from './app.component'
import { ProjectPageComponent } from './components/project-page/project-page.component'

import {StoryblokService} from './services/storyblok.service'

const routes: Routes = [
  { path: '*', redirectTo: '/' },
  {
    path: '',
    component: PageComponent
  },
  {
    path: 'project/:slug',
    component: ProjectPageComponent,
    pathMatch:'full',
    data: {animation: 'ProjectPage'}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', useHash: false, scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }